import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { NgxSpinnerService } from "ngx-spinner";
import { NavService } from './services/nav.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showMenu: boolean;
  constructor(public auth: AuthService, private spinner:NgxSpinnerService, public nav: NavService) {
    this.showMenu = false;
    this.spinner.show();
    console.log(`welcome to Laer ${environment.env}!`);
  }

  toggleMenu(value) {
    this.showMenu = value
  }

  toggleSpinner(value) {
    if (value === true) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }
}
